import { render, staticRenderFns } from "./antiParasitaireActions.vue?vue&type=template&id=3cbdc4ba"
import script from "./antiParasitaireActions.vue?vue&type=script&lang=js"
export * from "./antiParasitaireActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports